'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MoreIcon = require('../../icons/MoreIcon');

var _MoreIcon2 = _interopRequireDefault(_MoreIcon);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_EVENTS = ['mousedown', 'touchstart'];

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode) {
  if (current === componentNode) {
    return true;
  }
  return false;
}

var Dropdown = function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown(props) {
    _classCallCheck(this, Dropdown);

    var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

    _this.bindDropdownRef = function (c) {
      _this._instance = c;
    };

    _this.state = {
      menuVisible: props.isOpen
    };

    _this.onTriggerClick = _this.onTriggerClick.bind(_this);
    _this.closeMenu = _this.closeMenu.bind(_this);
    _this.outsideCheck = _this.outsideCheck.bind(_this);
    return _this;
  }

  _createClass(Dropdown, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        closeMenu: this.closeMenu
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.menuVisible) {
        this.addClickListeners();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        menuVisible: nextProps.isOpen
      });

      if (nextProps.isOpen !== this.state.menuVisible) {
        if (nextProps.isOpen) {
          this.addClickListeners();
        } else {
          this.removeClickListeners();
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeClickListeners();
    }
  }, {
    key: 'addClickListeners',
    value: function addClickListeners() {
      var _this2 = this;

      DEFAULT_EVENTS.forEach(function (eventName) {
        document.addEventListener(eventName, _this2.outsideCheck);
      });
    }
  }, {
    key: 'removeClickListeners',
    value: function removeClickListeners() {
      var _this3 = this;

      DEFAULT_EVENTS.forEach(function (eventName) {
        document.removeEventListener(eventName, _this3.outsideCheck);
      });
    }
  }, {
    key: 'outsideCheck',
    value: function outsideCheck(evt) {
      var current = evt.target;
      var found = false;
      // If source=local then this event came from "somewhere"
      // inside and should be ignored. We could handle this with
      // a layered approach, too, but that requires going back to
      // thinking in terms of Dom node nesting, running counter
      // to React's "you shouldn't care about the DOM" philosophy.
      while (current.parentNode) {
        found = isNodeFound(current, this._instance);
        if (found) return;
        current = current.parentNode;
      }
      // If element is in a detached DOM, consider it "not clicked
      // outside", as it cannot be known whether it was outside.
      if (current !== document) return;
      this.closeMenu();
    }
  }, {
    key: 'onTriggerClick',
    value: function onTriggerClick() {
      this.addClickListeners();
      this.setState({
        menuVisible: true
      });
    }
  }, {
    key: 'closeMenu',
    value: function closeMenu() {
      this.removeClickListeners();
      this.setState({
        menuVisible: false
      });
      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var menuClass = (0, _classnames3.default)((_classnames = {}, _defineProperty(_classnames, _styles2.default['dropdown__menu'], true), _defineProperty(_classnames, _styles2.default['dropdown__menu--dark'], this.state.menuVisible && this.props.env === 'dark'), _defineProperty(_classnames, _styles2.default['dropdown__menu--light'], this.state.menuVisible && this.props.env === 'light'), _defineProperty(_classnames, _styles2.default['dropdown__menu--closed'], !this.state.menuVisible), _defineProperty(_classnames, _styles2.default['dropdown__menu--top'], this.props.position === 'top'), _classnames));

      var trigger = this.props.menuOnly ? null : _react2.default.createElement(
        'span',
        {
          className: _styles2.default['dropdown__trigger'],
          onClick: this.onTriggerClick },
        _react2.default.createElement(_MoreIcon2.default, { size: 'small' })
      );

      return _react2.default.createElement(
        'div',
        { className: _styles2.default.dropdown, ref: this.bindDropdownRef },
        trigger,
        _react2.default.createElement(
          'ul',
          { className: menuClass },
          this.props.children
        )
      );
    }
  }]);

  return Dropdown;
}(_react.Component);

Dropdown.propTypes = {
  children: _react.PropTypes.node,
  env: _react.PropTypes.oneOf(['dark', 'light']),
  isOpen: _react.PropTypes.bool,
  onClose: _react.PropTypes.func,
  position: _react.PropTypes.oneOf(['top', 'bottom']),
  menuOnly: _react.PropTypes.bool
};
Dropdown.childContextTypes = {
  closeMenu: _react.PropTypes.func.isRequired
};
Dropdown.defaultProps = {
  isOpen: false,
  position: 'bottom',
  env: 'light',
  menuOnly: false
};
exports.default = Dropdown;